export function trackContact(type: "mail" | "phone" | "social") {
  window.gtag("event", "contact", {
    value: type,
  });
}
